export default "__VITE_ASSET__BeUMz106__"